import { useSelector } from 'react-redux';
import { PLATE_TYPE, TRANSACTION_TYPE_MAP } from '../docs/constants';
import { selectRefiDocsFormData } from '../../redux-state/selectors';

function TransactionInfoRefiDoc() {
  const refiDocsFormData = useSelector(selectRefiDocsFormData)

  const formatDate = (dateString) => {
    // Split the string by the hyphen
    const [year, month, day] = dateString.split('-');

    // Return them in the desired order with slashes
    return `${month}/${day}/${year}`;
  }

  return (
    <div>
      <div className='border-t-2 border-t-gray-100 mb-3'>
        <div className='text-gray-700 mt-6 font-bold'>
          Transaction Information
        </div>
      </div>

      <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-6'>
        <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
          {refiDocsFormData.transactionType &&
            <div className='flex flex-row justify-between'>
              <div>
                Transaction Type:
              </div>
              <div className='font-medium'>
                {refiDocsFormData? TRANSACTION_TYPE_MAP[refiDocsFormData.transactionType]: ""}
              </div>
            </div>
          }

          {refiDocsFormData?.transactionDate &&
            <div className='flex flex-row justify-between'>
              <div>
                Transaction Date:
              </div>
              <div className='font-medium'>
                {formatDate(refiDocsFormData?.transactionDate)}
              </div>
            </div>
          }

          {refiDocsFormData?.plateType &&
            <div className='flex flex-row justify-between'>
              <div>
                Plate type:
              </div>
              <div className='font-medium'>
                {PLATE_TYPE[refiDocsFormData?.plateType]}
              </div>
            </div>
          }


          {refiDocsFormData?.plateNumber &&
            <div className='flex flex-row justify-between'>
              <div>
                Plate Number:
              </div>
              <div className='font-medium'>
                {refiDocsFormData?.plateNumber}
              </div>
            </div>
          }

          {refiDocsFormData?.docsFees &&
            <div className='flex flex-row justify-between'>
              <div>
                Docs Price:
              </div>
              <div className='font-medium'>
                {Number(refiDocsFormData?.docsFees || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          {refiDocsFormData?.insurancePackages &&
            <div className='flex flex-row justify-between'>
              <div>
                Insurance package:
              </div>
              <div className='font-medium'>
                {Number(refiDocsFormData?.insurancePackages || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          {refiDocsFormData?.protectionPackages &&
            <div className='flex flex-row justify-between'>
              <div>
                Theft Protection:
              </div>
              <div className='font-medium'>
                {Number(refiDocsFormData?.protectionPackages || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          <div className='flex flex-row justify-between'>
            <div>
              Plate Transfer:
            </div>
            <div className='font-medium'>
              {refiDocsFormData?.plateTransfer ? "yes" : 'No'}
            </div>
          </div>
        </div>

        <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
          {refiDocsFormData?.uploadDate &&
            <div className='flex flex-row justify-between'>
              <div>
                Uploaded Date:
              </div>
              <div className='font-medium'>
                {formatDate(refiDocsFormData?.uploadDate)}
              </div>
            </div>
          }

          {refiDocsFormData?.driverCategory &&
            <div className='flex flex-row justify-between'>
              <div>
                Driver Category:
              </div>
              <div className='font-medium'>
                {refiDocsFormData?.driverCategory}
              </div>
            </div>
          }

          {refiDocsFormData?.basePrice &&
            <div className='flex flex-row justify-between'>
              <div>
                Base Price:
              </div>
              <div className='font-medium'>
              {Number(refiDocsFormData?.basePrice || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          {refiDocsFormData?.additionalFees &&
          <div className='flex flex-row justify-between'>
            <div>
              Additional Fee:
            </div>
            <div className='font-medium'>
              {Number(refiDocsFormData?.additionalFees || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
            </div>
          </div>
          }

          {refiDocsFormData?.protectionPackages &&
            <div className='flex flex-row justify-between'>
              <div>
                Protection Packages:
              </div>
              <div className='font-medium'>
                {Number(refiDocsFormData?.protectionPackages || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          {refiDocsFormData?.extendedWarranties &&
            <div className='flex flex-row justify-between'>
              <div>
                Extended Warranties:
              </div>
              <div className='font-medium'>
                {Number(refiDocsFormData?.extendedWarranties || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          <div className='flex flex-row justify-between'>
            <div>
              Military:
            </div>
            <div className='font-medium'>
              {refiDocsFormData?.military? "Yes": "No"}
            </div>
          </div>

          <div className='flex flex-row justify-between'>
            <div>
              Lien:
            </div>
            <div className='font-medium'>
              {refiDocsFormData?.lien? "Yes": "No"}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TransactionInfoRefiDoc
